import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlidesTallAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M4 18V2H16V6H20V22H8V18H4ZM14 4V6H8V16H6V4H14ZM15 11H13V13H11V15H13V17H15V15H17V13H15V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesTallAdd;
